/* eslint-disable react/prop-types */
import React, { Component } from 'react';
// import fetch from 'cross-fetch';
import get from 'lodash/get';
import T from 'i18n-react';
import {
  // ApiPrefix, json,
  nextPath,
  setCookie,
} from 'util/icwUtility';
import { ALI_LOGIN_PATH } from 'shared/routes';
import RegistrationForm from './RegistrationForm';
import PostRegistration from './PostRegistration';
// For polyfill
import 'core-js/es/map';
import 'core-js/es/set';
import 'cross-fetch/polyfill';
import { AUTH_TYPES, REGISTRATION_STATUS } from './const';

class RegistrationFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        email: '',
        password: '',
        agreeTerm: true,
      },
      touched: {
        email: false,
        password: false,
        agreeTerm: false,
      },
      errors: {
        email: null,
        agreeTerm: null,
      },
      showPassword: false,
      passwordCriteria: {
        lowerChar: false,
        upperChar: false,
        minimumChar: false,
        number: false,
      },
      isSubmitted: false,
      currentUser: null,
      resent: false,
      showModalConfirmEmail: true,
    };
    this.validateEmail = this.validateEmail.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validate = this.validate.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleTogglePassword = this.handleTogglePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResend = this.handleResend.bind(this);
    this.handleCloseVerificationPopup = this.handleCloseVerificationPopup.bind(this);
  }

  updateState(type, input, message, cb = null) {
    this.setState(
      (prevState) => ({
        ...prevState,
        [type]: {
          ...prevState[type],
          [input]: message,
        },
      }),
      cb
    );
  }

  validateEmail(email) {
    const emailValidateRegex = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|io|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/;
    if (email.length === 0) {
      this.updateState('errors', 'email', T.translate('registration.errors.noEmptyEmail'));
    } else if (!emailValidateRegex.test(email.toLocaleLowerCase().trim())) {
      this.updateState('errors', 'email', T.translate('registration.errors.invalidEmailFormat'));
    } else {
      this.updateState('errors', 'email', null);
    }
  }

  validatePassword(password) {
    if (password.length === 0) {
      this.updateState('errors', 'password', T.translate('registration.errors.noEmptyPassword'));
    } else {
      this.updateState('errors', 'password', null);
    }
  }

  validate(name, value) {
    switch (name) {
      case 'email':
        this.validateEmail(value);
        break;
      case 'password':
        this.validatePassword(value);
        break;
      default:
    }
  }

  handleTogglePassword() {
    this.setState((prevState) => ({
      ...prevState,
      showPassword: !prevState.showPassword,
    }));
  }

  handleBlur(e) {
    const { name, value } = e.target;
    this.updateState('touched', name, true, this.validate(name, value));
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.updateState('values', name, value, this.validate(name, value));
  }

  handleSubmit(data, event) {
    const { onRegistration } = this.props;

    const { authType = AUTH_TYPES.simple } = data;

    const onSuccess = (res) => {
      const { userVerification, history } = this.props;

      this.setState((prevState) => ({
        ...prevState,
        isSubmitted:
          get(userVerification, 'data') === REGISTRATION_STATUS.verify_in_progress ||
          authType === AUTH_TYPES.simple,
        currentUser: { email: prevState.values.email },
      }));

      // if using social account registration, use token response redirect to dashboard
      if (authType === AUTH_TYPES.social) {
        const { token, isActivated = true } = res; // activated by default
        if (!token) return;

        setCookie('token', token);
        setCookie('activated_user', isActivated);
        history.replace('/');
      }

      // tracking google adwords (only for prod)
      if (window.location.hostname.includes('qmas.icw.io')) {
        window.gtag('event', 'conversion', { send_to: 'AW-413691517/d-wFCK-ux4UDEP3cocUB' });
      }
    };

    const onFailure = (err) => {
      if (get(err, 'message') === 'exist_user') {
        this.updateState('errors', 'email', T.translate('registration.errors.existUser'));
      }
    };

    let params = { authType };

    if (authType === AUTH_TYPES.simple) {
      event.preventDefault();
      const { values } = this.state;
      params = { ...params, ...values };
    } else if (authType === AUTH_TYPES.social) {
      params = { ...params, ...data };
    }
    params.signupFrom = 'alibaba';

    onRegistration(params, onSuccess, onFailure);
  }

  // handleSubmit(e) {
  //   const { values } = this.state;
  //   e.preventDefault();
  //   // eslint-disable-next-line no-useless-escape
  //   const tempCompanyName = ['ICW-', values.email.split(/@[\w\.]+$/i, 1)].join('');
  //
  //   const body = {
  //     ...values,
  //     company_name: tempCompanyName,
  //   };
  //
  //   fetch(`${ApiPrefix}/user/create`, {
  //     method: 'POST',
  //     headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  //     credentials: 'include',
  //     body: JSON.stringify(body),
  //   })
  //     .then((response) =>
  //       response.status >= 200 && response.status < 300
  //         ? Promise.resolve(response)
  //         : Promise.reject(response)
  //     )
  //     .then(json)
  //     .then(() => {
  //       this.setState((prevState) => ({
  //         ...prevState,
  //         isSubmitted: true,
  //         currentUser: { email: prevState.values.email },
  //       }));
  //     }, json)
  //     .then((err) => {
  //       if (!!err.emailExists) {
  //         this.updateState('errors', 'email', T.translate(`registration.errors.emailExists`));
  //       }
  //     });
  // }

  handleResend() {
    const { onVerificationResend } = this.props;
    const { currentUser } = this.state;

    onVerificationResend({ email: get(currentUser, 'email') }, () => {
      this.setState({
        resent: true,
      });
      this.handleCloseVerificationPopup();
    });
  }

  // handleResend(email) {
  //   fetch(`${ApiPrefix}/user/resend_confirmation_email`, {
  //     method: 'POST',
  //     headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  //     credentials: 'include',
  //     body: JSON.stringify({ email }),
  //   })
  //     .then(json)
  //     .then(() =>
  //       this.setState({
  //         resent: true,
  //       })
  //     )
  //     .catch((err) => {
  //       if (err.response) {
  //       } else if (err.request) {
  //       } else {
  //       }
  //     });
  // }

  handleCloseVerificationPopup() {
    const { history, locale } = this.props;

    this.setState({
      isSubmitted: false,
    });

    nextPath(history)(`/${locale}${ALI_LOGIN_PATH}`);
  }

  render() {
    const { locale } = this.props;
    const { currentUser, resent, isSubmitted } = this.state;
    return (
      <>
        <PostRegistration
          locale={locale}
          email={get(currentUser, 'email')}
          resent={resent}
          open={isSubmitted}
          onClose={this.handleCloseVerificationPopup}
          onResend={this.handleResend}
        />
        <RegistrationForm
          locale={locale}
          handleSubmit={this.handleSubmit}
          handleTogglePassword={this.handleTogglePassword}
          handleChange={this.handleChange}
          handleBlur={this.handleBlur}
          updateState={this.updateState}
          {...this.state}
          {...this.props}
        />
      </>
    );
  }
}

export default RegistrationFormContainer;
